<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.pb_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pb_kind">
            <label class="weui-form-preview__label">{{customLabel.pb_kind || "退款单类型"}}</label>
            <em class="weui-form-preview__value">{{form.main.pb_kind}}</em>
          </div>
          <div class="weui-form-preview__item" slot="pb_vendname">
            <label class="weui-form-preview__label">{{customLabel.pb_vendname || "供应商名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.pb_vendname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pb_bankinfo">
            <label class="weui-form-preview__label">{{customLabel.pb_bankinfo || "付款信息"}}</label>
            <span class="weui-form-preview__value">{{form.main.pb_bankinfo}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pb_buyername">
            <label class="weui-form-preview__label">{{customLabel.pb_buyername || "采购员"}}</label>
            <span class="weui-form-preview__value">{{form.main.pb_buyername}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pb_date">
            <label class="weui-form-preview__label">{{customLabel.pb_date || "日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.pb_date}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pb_currency"> 
            <label class="weui-form-preview__label">{{customLabel.pb_currency || "币种"}}</label>
            <span class="weui-form-preview__value">{{form.main.pb_currency}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pb_valeftamount">
            <label class="weui-form-preview__label">{{customLabel.pb_valeftamount || "总欠款(元)"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{form.main.pb_valeftamount}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pb_sourcetype"> 
            <label class="weui-form-preview__label">{{customLabel.pb_sourcetype || "来源类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.pb_sourcetype}}</span>
          </div>
         
          <div class="weui-form-preview__item" slot="pb_preamount" v-if="form.main.pb_kind == '预付退款单'">
            <label class="weui-form-preview__label">{{customLabel.pb_preamount || "预付退款金额"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{form.main.pb_preamount}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pb_text1 || '自定义字段1'"
          v-model="form.main.pb_text1" slot="pb_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pb_text2 || '自定义字段2'"
          v-model="form.main.pb_text2" slot="pb_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pb_text3 || '自定义字段3'"
          v-model="form.main.pb_text3" slot="pb_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pb_text4 || '自定义字段4'"
          v-model="form.main.pb_text4" slot="pb_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pb_text5 || '自定义字段5'"
          v-model="form.main.pb_text5" slot="pb_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="item in form.items1" :key="item.id">
          <div class="form-detail-preview_num">{{item.pd_detno}}</div>
           <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="pd_bankname">
            <label class="weui-form-preview__label">{{customLabel.pd_bankname || "记账科目"}}</label>
            <span class="weui-form-preview__value">{{item.pd_bankcode}}{{item.pd_bankname}}</span>
          </div>
         
          <div class="weui-form-preview__item" slot="pd_amount">
            <label class="weui-form-preview__label">{{customLabel.pd_amount || "付款金额"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.pd_amount,'¥#,##0.00')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_remark">
            <label class="weui-form-preview__label">{{customLabel.pd_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{item.pd_remark}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pd_text1 || '自定义字段1'"
          v-model="item.pd_text1" slot="pd_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pd_text2 || '自定义字段2'"
          v-model="item.pd_text2" slot="pd_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pd_text3 || '自定义字段3'"
          v-model="item.pd_text3" slot="pd_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pd_text4 || '自定义字段4'"
          v-model="item.pd_text4" slot="pd_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pd_text5 || '自定义字段5'"
          v-model="item.pd_text5" slot="pd_text5" hidden="true" />
           </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="item in form.items2" :key="item.id">
          <div class="form-detail-preview_num">{{item.pbd_detno}}</div>
           <custom-layout :view-config="customViewConfig" position="detail2">
          <div class="weui-form-preview__item" slot="pbd_ordercode">
            <label class="weui-form-preview__label">{{customLabel.pbd_ordercode || "来源单号"}}</label>
            <span class="weui-form-preview__value">{{item.pbd_ordercode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pbd_buyername">
            <label class="weui-form-preview__label">{{customLabel.pbd_buyername || "采购员"}}</label>
            <span class="weui-form-preview__value">{{item.pbd_buyername}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pbd_orderkind">
            <label class="weui-form-preview__label">{{customLabel.pbd_orderkind || "单据类型"}}</label>
            <span class="weui-form-preview__value">{{item.pbd_orderkind}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pbd_sldate">
            <label class="weui-form-preview__label">{{customLabel.pbd_sldate || "单据日期"}}</label>
            <span class="weui-form-preview__value" >{{dateFormat(item.pbd_sldate,'yyyy-MM-dd')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pbd_amount">
            <label class="weui-form-preview__label">{{customLabel.pbd_amount || "单据金额"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.pbd_amount,'¥#,##0.00')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="sl_yamount">
            <label class="weui-form-preview__label">{{customLabel.sl_yamount || "已核销金额"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.sl_yamount,'¥#,##0.00')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="sl_namount">
            <label class="weui-form-preview__label">{{customLabel.sl_namount || "未核销金额"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.sl_namount,'¥#,##0.00')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pbd_nowbalance">
            <label class="weui-form-preview__label">{{customLabel.pbd_nowbalance || "本次退款金额"}}</label>
            <b><span class="weui-form-preview__value">{{numberFormat(item.pbd_nowbalance,'¥#,##0.00')}}</span></b>
          </div>
          
          <custom-field :readOnly="true" :label="customLabel.pbd_text1 || '自定义字段1'"
          v-model="item.pbd_text1" slot="pbd_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pbd_text2 || '自定义字段2'"
          v-model="item.pbd_text2" slot="pbd_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pbd_text3 || '自定义字段3'"
          v-model="item.pbd_text3" slot="pbd_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pbd_text4 || '自定义字段4'"
          v-model="item.pbd_text4" slot="pbd_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pbd_text5 || '自定义字段5'"
          v-model="item.pbd_text5" slot="pbd_text5" hidden="true" />
           </custom-layout>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.pb_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{form.main.pb_remark}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pb_auditman">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{form.main.pb_auditman}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-show="form.main.pb_attach">
        <div class="weui-panel__hd">附件</div>
        <div class="weui-form-preview__bd">
          <file-list :value="form.main.pb_attach" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/money/paybalanceback",
      caller: "PayBalanceBack",
      xtype: "money-paybalanceback-formpanel",
    };
  }
}
</script>